import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'


export function getToken() {
  return Cookies.get(TokenKey)
}

export function getTokenByDomain() {
  return Cookies.get(TokenKey, {path: '/', domain: '.bankwitherp.com' })
}

export function setToken(token) {
  return Cookies.set(TokRenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function removeTokenByDomain() {
  return Cookies.remove(TokenKey, {path: '/', domain: '.bankwitherp.com' })
}



// WEBPACK FOOTER //
// ./src/util/auth.js